import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import * as OrganizationPersonActions from 'web-app/react/entities/organization-persons/actions';

import * as Actions from './actions';

export interface ManageOrganizationEmployeesStateProps {
    readonly loading: boolean;
    readonly deletingPersonId: string | undefined;
}
export class ManageOrganizationEmployeesState extends Record<ManageOrganizationEmployeesStateProps>({
    loading: false,
    deletingPersonId: undefined,
}) {}

export default makeReducer<ManageOrganizationEmployeesState>(
    [
        match(Actions.fetchData, state => {
            return state.merge({
                loading: true,
            });
        }),
        match(Actions.fetchDataSuccess, state => {
            return state.merge({
                loading: false,
            });
        }),
        match(Actions.fetchDataFailed, state => {
            return state.merge({
                loading: false,
            });
        }),
        match(OrganizationPersonActions.deletePerson, (state, {payload}) => {
            return state.merge({
                deletingPersonId: payload.person.organizationPersonId,
            });
        }),
        match(OrganizationPersonActions.deletePersonSuccess, state => {
            return state.merge({
                deletingPersonId: undefined,
            });
        }),
        match(OrganizationPersonActions.deletePersonFailed, state => {
            return state.merge({
                deletingPersonId: undefined,
            });
        }),
        match(OrganizationPersonActions.deletePersonAborted, state => {
            return state.merge({
                deletingPersonId: undefined,
            });
        }),
    ],
    new ManageOrganizationEmployeesState(),
);
